import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {CountryList} from "../../address/interface/countryList";
import {RequestMapperService} from "../../request-mapper.service";
import {Observable} from "rxjs";

@Injectable({
	providedIn: 'root'
})
export class SharedTransmissionService {

	constructor(
		private _http: HttpClient
	) {
	}

	public fetchCountryList(): Observable<CountryList[]> {
		return this._http.get<CountryList[]>(RequestMapperService.COUNTRY_LIST);
	}
}
